export default __webpack_public_path__ + "static/media/Avatar-18.8eaebf54.png";